import { Resend } from 'resend';
import { EMAIL_CONFIG } from './config';
import { waitlistConfirmationTemplate } from './templates';

// Only initialize Resend if API key is available
const resend = import.meta.env.VITE_RESEND_API_KEY 
  ? new Resend(import.meta.env.VITE_RESEND_API_KEY)
  : null;

interface EmailData {
  to: string;
  firstName: string;
}

export async function sendWaitlistConfirmation({ to, firstName }: EmailData) {
  if (!resend) {
    console.warn('Resend API key not configured. Skipping email send.');
    return true; // Return success to not block the flow
  }

  try {
    const { data, error } = await resend.emails.send({
      from: EMAIL_CONFIG.from,
      to: [to],
      subject: EMAIL_CONFIG.subjects.waitlistConfirmation,
      html: waitlistConfirmationTemplate(firstName)
    });

    if (error) {
      console.error('Error sending confirmation email:', error);
      return false;
    }

    return true;
  } catch (err) {
    console.error('Failed to send confirmation email:', err);
    return false;
  }
}